module.exports = __webpack_public_path__ + "src/img/rotateLeft.5b506eda.svg";